import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Filtro } from '@/modules/AgendaModule'
import FiltroDaAgenda from '@/components/FiltroDaAgenda.vue'
import { agenda } from '@/store'

interface Opcao {
	text: string,
	value: 'grau' | 'tipo',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendaToolbarExpanded',
  setup(__props) {

const opcoes: Opcao[] = [
	{
		text: 'Grau',
		value: 'grau',
	},
	{
		text: 'Tipo',
		value: 'tipo',
	},
]

const tipoDaLabel = computed({
	get: () => agenda.tipoDaLabel,
	set: (tipo: 'grau' | 'tipo') => agenda.setTipoDaLabel(tipo),
})

const opcao = computed(() => opcoes
	.find(({value}) => value === tipoDaLabel.value) as Opcao)

function trocarOpcao() {
	const indice = opcoes
		.findIndex(({value}) => value === tipoDaLabel.value)
	tipoDaLabel.value = indice !== -1
		? opcoes[(indice + 1) % 2].value
		: 'grau'
}

const filtro = computed({
	get: () => agenda.filter,
	set: (novoFiltro: Filtro) => agenda.setFilter(novoFiltro),
})

return { __sfc: true,opcoes, tipoDaLabel, opcao, trocarOpcao, filtro, FiltroDaAgenda, agenda }
}

})